export enum WhatsappOptionTypeEnum {
  WHATSAPP = "WHATSAPP",
  WHATSAPP_BUSINESS = "WHATSAPP_BUSINESS",
  WEB = "WEB"
}

export const WhatsappOptionTypeEnumValues = [
  WhatsappOptionTypeEnum.WHATSAPP,
  WhatsappOptionTypeEnum.WHATSAPP_BUSINESS,
  WhatsappOptionTypeEnum.WEB
]